import Util from "../../lib/util.js";
import FSM from "../../lib/fsm.js";

import { removeContributor, invitePerson } from "../../Contributor.svelte";

let Contributor = {};

Contributor.isInitialized = function(contributor) {
  if (contributor) {
    let {user, commissionPercentage, hourlySalary, marketAnnualSalary} = contributor;
    return (commissionPercentage != null && commissionPercentage != undefined) && (hourlySalary || marketAnnualSalary);
  }
};

// TODO: this implementation is a hack
Contributor.resendInvitation = function(projectId, contributorId, email) {
  return removeContributor(projectId, contributorId).then(res => {
    return invitePerson(projectId, email)
  })
};

Contributor.fmtName = function(contributor) {
    let role = contributor.title;

    if (!contributor.user) {
      return contributor.title;
    }

    let first = contributor.user.firstName;
    let last = contributor.user.lastName;
    let email = contributor.user.emailAddress;

    let STATE = FSM.init()
                    .add("NO_NAME", !first && !last)
                    .add("FULL_NAME", first && last)
                    .add("PARTIAL_NAME", (first && !last) || (last && !first))
                    .determine()

    switch(STATE) {
        case "NO_NAME":
            return role || email;
        case "FULL_NAME":
            return `${first} ${last}`;
        case "PARTIAL_NAME":
            return `${first || last} (${role || email})`;
        default:
            throw `Unexpected state '${STATE}' in Project.contributorName()!`;
    }
};

export default Contributor;